var countryCodeCurrency = {"BD": "BDT", "BE": "EUR", "BF": "XOF", "BG": "BGN", "BA": "BAM", "BB": "BBD", "WF": "XPF", "BL": "EUR", "BM": "BMD", "BN": "BND", "BO": "BOB", "BH": "BHD", "BI": "BIF", "BJ": "XOF", "BT": "BTN", "JM": "JMD", "BV": "NOK", "BW": "BWP", "WS": "WST", "BQ": "USD", "BR": "BRL", "BS": "BSD", "JE": "GBP", "BY": "BYR", "BZ": "BZD", "RU": "RUB", "RW": "RWF", "RS": "RSD", "TL": "USD", "RE": "EUR", "TM": "TMT", "TJ": "TJS", "RO": "RON", "TK": "NZD", "GW": "XOF", "GU": "USD", "GT": "GTQ", "GS": "GBP", "GR": "EUR", "GQ": "XAF", "GP": "EUR", "JP": "JPY", "GY": "GYD", "GG": "GBP", "GF": "EUR", "GE": "GEL", "GD": "XCD", "GB": "GBP", "GA": "XAF", "SV": "USD", "GN": "GNF", "GM": "GMD", "GL": "DKK", "GI": "GIP", "GH": "GHS", "OM": "OMR", "TN": "TND", "JO": "JOD", "HR": "HRK", "HT": "HTG", "HU": "HUF", "HK": "HKD", "HN": "HNL", "HM": "AUD", "VE": "VEF", "PR": "USD", "PS": "ILS", "PW": "USD", "PT": "EUR", "SJ": "NOK", "PY": "PYG", "IQ": "IQD", "PA": "PAB", "PF": "XPF", "PG": "PGK", "PE": "PEN", "PK": "PKR", "PH": "PHP", "PN": "NZD", "PL": "PLN", "PM": "EUR", "ZM": "ZMK", "EH": "MAD", "EE": "EUR", "EG": "EGP", "ZA": "ZAR", "EC": "USD", "IT": "EUR", "VN": "VND", "SB": "SBD", "ET": "ETB", "SO": "SOS", "ZW": "ZWL", "SA": "SAR", "ES": "EUR", "ER": "ERN", "ME": "EUR", "MD": "MDL", "MG": "MGA", "MF": "EUR", "MA": "MAD", "MC": "EUR", "UZ": "UZS", "MM": "MMK", "ML": "XOF", "MO": "MOP", "MN": "MNT", "MH": "USD", "MK": "MKD", "MU": "MUR", "MT": "EUR", "MW": "MWK", "MV": "MVR", "MQ": "EUR", "MP": "USD", "MS": "XCD", "MR": "MRO", "IM": "GBP", "UG": "UGX", "TZ": "TZS", "MY": "MYR", "MX": "MXN", "IL": "ILS", "FR": "EUR", "IO": "USD", "SH": "SHP", "FI": "EUR", "FJ": "FJD", "FK": "FKP", "FM": "USD", "FO": "DKK", "NI": "NIO", "NL": "EUR", "NO": "NOK", "NA": "NAD", "VU": "VUV", "NC": "XPF", "NE": "XOF", "NF": "AUD", "NG": "NGN", "NZ": "NZD", "NP": "NPR", "NR": "AUD", "NU": "NZD", "CK": "NZD", "XK": "EUR", "CI": "XOF", "CH": "CHF", "CO": "COP", "CN": "CNY", "CM": "XAF", "CL": "CLP", "CC": "AUD", "CA": "CAD", "CG": "XAF", "CF": "XAF", "CD": "CDF", "CZ": "CZK", "CY": "EUR", "CX": "AUD", "CR": "CRC", "CW": "ANG", "CV": "CVE", "CU": "CUP", "SZ": "SZL", "SY": "SYP", "SX": "ANG", "KG": "KGS", "KE": "KES", "SS": "SSP", "SR": "SRD", "KI": "AUD", "KH": "KHR", "KN": "XCD", "KM": "KMF", "ST": "STD", "SK": "EUR", "KR": "KRW", "SI": "EUR", "KP": "KPW", "KW": "KWD", "SN": "XOF", "SM": "EUR", "SL": "SLL", "SC": "SCR", "KZ": "KZT", "KY": "KYD", "SG": "SGD", "SE": "SEK", "SD": "SDG", "DO": "DOP", "DM": "XCD", "DJ": "DJF", "DK": "DKK", "VG": "USD", "DE": "EUR", "YE": "YER", "DZ": "DZD", "US": "USD", "UY": "UYU", "YT": "EUR", "UM": "USD", "LB": "LBP", "LC": "XCD", "LA": "LAK", "TV": "AUD", "TW": "TWD", "TT": "TTD", "TR": "TRY", "LK": "LKR", "LI": "CHF", "LV": "EUR", "TO": "TOP", "LT": "LTL", "LU": "EUR", "LR": "LRD", "LS": "LSL", "TH": "THB", "TF": "EUR", "TG": "XOF", "TD": "XAF", "TC": "USD", "LY": "LYD", "VA": "EUR", "VC": "XCD", "AE": "AED", "AD": "EUR", "AG": "XCD", "AF": "AFN", "AI": "XCD", "VI": "USD", "IS": "ISK", "IR": "IRR", "AM": "AMD", "AL": "ALL", "AO": "AOA", "AQ": "", "AS": "USD", "AR": "ARS", "AU": "AUD", "AT": "EUR", "AW": "AWG", "IN": "INR", "AX": "EUR", "AZ": "AZN", "IE": "EUR", "ID": "IDR", "UA": "UAH", "QA": "QAR", "MZ": "MZN"}; // taken from http://country.io/currency.json


var isCurrencySwitcherAvailable = false;

function afterCurrencySwitcherInit(){
  isCurrencySwitcherAvailable = true;
  customizeDoubly();
}

function checkAndShowCurrencyHeader(){  
    if(isCurrencySwitcherAvailable == true){
      $('.location-currency-message').show();
    }else{
      setTimeout(function(){ checkAndShowCurrencyHeader();  }, 1000);
    }
   
}
 
function customizeDoubly() {
  	setTimeout(function(){
  		if(typeof jQueryGrizzly != 'undefined' && typeof IPRedirect.location != 'undefined' && IPRedirect.location.country_code != site_country){ 
  			if($('[name=doubly-currencies]').closest('.location-currency-message').length) { 
	  			jQueryGrizzly('[name=doubly-currencies]').unbind('change');

	  			$('.btn-currency-go').on('click',function(){
	  				    var newCurrency = jQueryGrizzly('[name=doubly-currencies] option:selected').val();
                if(typeof newCurrency == 'undefined' ||  newCurrency == null){
                  newCurrency = DoublyGlobalCurrency.cookie.read();
                }
	  				    setCookie("merch_currency",newCurrency,365);
                DoublyGlobalCurrency.convertAll(newCurrency); /* in case more than 1 currency switcher, update value of all of them */
                jQueryGrizzly('[name=doubly-currencies]').val(jQueryGrizzly(this).val());

                if(!$(this).hasClass('trigger-from-nav')){ 
                  $('.location-currency-message').hide();
                  cloneDoublyToNavHeader(); 
                }else{ 
                  $('.btn-currency-go').removeClass('trigger-from-nav');
                }
	  			});

          if(getMerchCookie('merch_currency') != null && getMerchCookie('merch_currency') != ""){ 

            cloneDoublyToNavHeader();
            $("body").addClass('body-nav-currency'); 

          }else{

            if(typeof IPRedirect.location != "undefined" && typeof IPRedirect.location.country_code != "undefined" && $('.doubly-nice-select ul li[data-value="'+countryCodeCurrency[IPRedirect.location.country_code]+'"]').length){
              $('.doubly-nice-select ul li').removeClass('selected');
              var currencyDrop = $('.doubly-nice-select ul li[data-value="'+countryCodeCurrency[IPRedirect.location.country_code]+'"]');

              currencyDrop.addClass('selected');
              $('.doubly-nice-select span.current').html('<span class="flags flags-'+currencyDrop.attr('data-country')+'"></span> &nbsp;'+currencyDrop.attr('data-display'));
              
               jQueryGrizzly('[name=doubly-currencies]').val(currencyDrop.attr('data-value'));
            }
            

            
          }

	  		}
	  	}
	 },1000); 
}

function cloneDoublyToNavHeader(){
  $("body").addClass('body-nav-currency');
  $(".currency-nav-container").html('');
  $("[name=doubly-currencies]").next('.doubly-nice-select').clone().appendTo(".currency-nav-container");
  $("[name=doubly-currencies]").next('.doubly-nice-select').clone().appendTo(".currency-nav-content-container");
  $(".currency-nav-container").show();
  $(".currency-nav-content-container").show();

  bindSelectCurrencyEvent(); 

  if($('.doubly-message-cart-row').length){ 
    $('.doubly-message-cart-row').show();  
  }

  //hide survey form 
 if(DoublyGlobalCurrency.currentCurrency != 'USD'){
   $('.product-survey.sec-area').hide(); 
   $('.doubly-message-cart-row').show(); 
 }else{
    $('.product-survey.sec-area').show(); 
    $('.doubly-message-cart-row').hide(); 
 }


}

function bindSelectCurrencyEvent(){

  if($('select[name=doubly-currencies]').length){ 
    $('select[name=doubly-currencies]').change(function(){
      setTimeout(function(){ 
          replaceCurrencyText(); 
      }, 100);  
    }) 
  }

}

function replaceCurrencyText(){
  
  if($('.doubly-message-cart-row').length){ 
    $('.doubly-message-cart-row .selected-currency').html(DoublyGlobalCurrency.currentCurrency); 
  } 

   //hide survey form
   if(DoublyGlobalCurrency.currentCurrency != 'USD'){
     $('.product-survey.sec-area').hide(); 
     $('.doubly-message-cart-row').show(); 
     $('.doubly-message-cart-row .doubly-message.free-offer-msg').show();
   }else{
      $('.product-survey.sec-area').show(); 
      $('.doubly-message-cart-row').hide(); 
   }
   
   if(typeof changePrice == "function"){
      changePrice("");
   }

 /* $('.current-currency').each(function(){
      $(this).html(DoublyGlobalCurrency.currentCurrency);
  })*/

}

function dbCnvrtCurrent(){
  if(typeof jQueryGrizzly != 'undefined' && typeof DoublyGlobalCurrency != "undefined" && typeof DoublyGlobalCurrency.cookie != "undefined" ){ 
    var newCurrency = jQueryGrizzly('[name=doubly-currencies] option:selected').val();
    if(typeof newCurrency == 'undefined' ||  newCurrency == null){
      newCurrency = DoublyGlobalCurrency.cookie.read();
    } 
    DoublyGlobalCurrency.convertAll(newCurrency);  
  }
}
$('body').on('click','.currency-nav-container .doubly-nice-select ul.list li, .currency-nav-content-container .doubly-nice-select ul.list li',function(){
    $('.btn-currency-go').addClass('trigger-from-nav');
    setTimeout(function(){ $('.btn-currency-go').trigger('click'); }, 100);
})

$('h2,p,h3,.tabPanelDetails,li,.item-price').each(function(){
  var tagTempHtml = $(this).html();
  if($(this).find('.money').length < 1 && tagTempHtml.search(/(\$[0-9\-\.\,]+)/g) != -1  && $(this).closest('.hbspt-form').length < 1 ){ 
    var fTempHtml = tagTempHtml.replace(/(\$[0-9\-\.\,]+)/g,"<span class='money'>$1</span>") ; 
    $(this).html(fTempHtml);
  }
})

$(window).load(function(){ 

  setTimeout(function(){
    $('h2,h3,p,.tabPanelDetails,li,.item-price:not(.size-item),.wisepop-content span').each(function(){
      var tagTempHtml = $(this).html();
      if($(this).find('.money').length < 1  && tagTempHtml.search(/(\$[0-9\-\.\,]+)/g) != -1  && $(this).closest('.hbspt-form').length < 1 ){ 
        var fTempHtml = tagTempHtml.replace(/(\$[0-9\-\.\,]+)/g,"<span class='money'>$1</span>") ; 
        $(this).html(fTempHtml);
      }
    }) 

    setTimeout(function(){
      dbCnvrtCurrent();
    },100);

  },1000);

})

// This function can be used to manually convert a currency value using Doubly
function convertAmountDirectly(cents,currentMoneyTxt){

  if(typeof DoublyGlobalCurrency != 'undefined'){ 
    var shopCurrency = 'USD';
    
    if (typeof cents == "string") {
      // Convert cents to a number, because keeping it as a string can cause miscalculations
      cents = parseFloat(cents);
    }

    if (shopCurrency != DoublyGlobalCurrency.currentCurrency) {
        cents = DoublyGlobalCurrency.convert(cents, shopCurrency, DoublyGlobalCurrency.currentCurrency);
    }  

     var newFormat = DoublyGlobalCurrency.moneyFormats[DoublyGlobalCurrency.currentCurrency][DoublyGlobalCurrency.format] || "{{amount}}";
     var isShopCurrency = (DoublyGlobalCurrency.currentCurrency == "USD") ? true : false;

     return DoublyGlobalCurrency.formatMoney(cents, newFormat, isShopCurrency, false);
   }else{
     return currentMoneyTxt;
   }

}
